export const ceilToDecimal = (value: number, decimalPoint: number) => {
	const factor = Math.pow(10, decimalPoint);
	return Math.ceil(value * factor) / factor;
};
